import Box from "@mui/material/Box";

import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";

const container_ = (theme) => ({
  visibility: "hidden", // temp
  display: "none", // temp
  // display: 'flex',
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    marginTop: "10px",
    justifyContent: "flex-start",
  },
});

const root_ = (theme) => ({
  padding: "0px",
  display: "flex",
  alignItems: "center",
  width: 500,
  borderBottom: "1px solid rgb(196, 196, 196)",
  borderRadius: "0px",
  [theme.breakpoints.down("sm")]: {
    maxWidth: "85vw",
  },
});

const input_ = (theme) => ({
  marginLeft: theme.spacing(1),
  flex: 1,
});

const iconButton_ = (theme) => ({
  padding: "6px",
});

export default function Input() {
  return (
    <Box sx={container_}>
      <Box sx={root_}>
        <InputBase
          // autoFocus={true}
          sx={input_}
          placeholder="Buildings, Rooms, Departments, etc"
        />
        <IconButton sx={iconButton_} aria-label="search" size="large">
          <SearchIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
